import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';

const BalanceSheet = () => {
  const [asOf, setAsOf] = useState(new Date().toISOString().split('T')[0]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handlePreview = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/accounting-reports/balance-sheet?as_of=${asOf}`);
      setData(res.data);
    } catch (error) {
      toast.error('Failed to load balance sheet');
    } finally {
      setLoading(false);
    }
  };

  const fmt = (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const sectionStyle = { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px', marginBottom: '16px' };
  const rowStyle = { display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '14px', borderBottom: '1px solid #f1f5f9' };
  const totalRowStyle = { ...rowStyle, fontWeight: 700, borderTop: '2px solid #e2e8f0', borderBottom: 'none', paddingTop: '10px' };

  return (
    <div className="card" style={{ padding: '24px', maxWidth: '700px' }}>
      <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '20px' }}>Balance Sheet</h2>

      {/* Filters */}
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ fontSize: '13px', fontWeight: 600 }}>As of</label>
          <input type="date" value={asOf} onChange={(e) => setAsOf(e.target.value)}
            style={{ padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px' }} />
        </div>
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
        <button onClick={handlePreview} disabled={loading}
          style={{ padding: '8px 20px', backgroundColor: '#5f9ea0', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }}>
          {loading ? 'Loading...' : 'Preview'}
        </button>
      </div>

      {/* Disclaimer */}
      <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '6px', padding: '16px', marginBottom: '20px', fontSize: '12px', color: '#1e40af' }}>
        <strong>Information Disclaimer</strong><br />
        The information provided is for general informational purposes only and should not be considered professional financial advice.
        It is your responsibility to verify the accuracy of the data.
      </div>

      {data && (
        <div>
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: 700 }}>Balance Sheet</h3>
            <p style={{ fontSize: '13px', color: '#64748b' }}>As of {new Date(data.as_of).toLocaleDateString()}</p>
          </div>

          {/* Assets */}
          <div style={sectionStyle}>
            <h4 style={{ fontSize: '14px', fontWeight: 700, marginBottom: '12px', color: '#059669' }}>ASSETS</h4>
            <div style={rowStyle}><span>Cash</span><span>{fmt(data.assets.cash)}</span></div>
            <div style={rowStyle}><span>Accounts Receivable</span><span>{fmt(data.assets.accounts_receivable)}</span></div>
            <div style={totalRowStyle}><span>Total Assets</span><span style={{ color: '#059669' }}>{fmt(data.assets.total)}</span></div>
          </div>

          {/* Liabilities */}
          <div style={sectionStyle}>
            <h4 style={{ fontSize: '14px', fontWeight: 700, marginBottom: '12px', color: '#dc2626' }}>LIABILITIES</h4>
            <div style={rowStyle}><span>Accounts Payable</span><span>{fmt(data.liabilities.accounts_payable)}</span></div>
            <div style={totalRowStyle}><span>Total Liabilities</span><span style={{ color: '#dc2626' }}>{fmt(data.liabilities.total)}</span></div>
          </div>

          {/* Equity */}
          <div style={sectionStyle}>
            <h4 style={{ fontSize: '14px', fontWeight: 700, marginBottom: '12px', color: '#4338ca' }}>EQUITY</h4>
            <div style={rowStyle}><span>Retained Earnings</span><span>{fmt(data.equity.retained_earnings)}</span></div>
            <div style={totalRowStyle}><span>Total Equity</span><span style={{ color: '#4338ca' }}>{fmt(data.equity.total)}</span></div>
          </div>

          <div style={{ ...sectionStyle, background: '#f0fdf4' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 700 }}>
              <span>Total Liabilities + Equity</span>
              <span style={{ color: '#059669' }}>{fmt(data.total_liabilities_equity)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BalanceSheet;
